<template>
  <div class="page-container">
    <Sidebar />
    <div class="main-content">
      <AdminTable
        apiEndpoint="/api/admin/collection-schemes"
        title="采收方案管理"
        :columns="columns"
        :formFields="formFields"
      />
    </div>
  </div>
</template>

<script>
import Sidebar from '../components/Sidebar.vue'
import AdminTable from '../components/AdminTable.vue'

export default {
  name: 'CollectionSchemesList',
  components: { Sidebar, AdminTable },
  data() {
    return {
      columns: [
        { key: 'variety_seq', label: '品种序号' },
        { key: 'year', label: '年份' },
        { key: 'variety_name', label: '品种名称' },
        { key: 'medical_code', label: '医保代码' },
        { key: 'standard', label: '执行标准' },
        { key: 'description', label: '性状描述' },
        { key: 'spec_code', label: '品规编号' },
        { key: 'spec', label: '规格' },
        { key: 'spec_requirement', label: '规格等级要求' }
      ],
      formFields: [
        { key: 'variety_seq', label: '品种序号', type: 'text' },
        { key: 'year', label: '年份', type: 'text', required: true },
        { key: 'variety_name', label: '品种名称', type: 'text', required: true },
        { key: 'medical_code', label: '医保代码', type: 'text' },
        { key: 'standard', label: '执行标准', type: 'text' },
        { key: 'description', label: '性状描述', type: 'textarea' },
        { key: 'spec_code', label: '品规编号', type: 'text' },
        { key: 'spec', label: '规格', type: 'select', options: [
          { value: '选货', label: '选货' },
          { value: '统货', label: '统货' }
        ] },
        { key: 'spec_requirement', label: '规格等级要求', type: 'textarea' }
      ]
    }
  }
}
</script>

<style scoped>
.page-container { display: flex; min-height: 100vh; background: #f5f5f5; }
.main-content { flex: 1; padding: 30px; margin-left: 260px; }
</style>
